import React from "react";
import { Button } from "antd";
import AdminAddVendorAccount from "../../components/tables/AdminAddVendorAccount";

const AdminAddVendorAccountPage = () => {
	return (
		<>
			<AdminAddVendorAccount button={Button} />
		</>
	);
};

export default AdminAddVendorAccountPage;
